import React, { useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ReactGA4 from "react-ga4";
import { Box, Typography } from "@mui/material";

import routes from "routes";
import { useAuth } from "providers/Auth";

import { ModalStyle, WhiteButton } from "components/Styled";
import Loading from "components/Loading";
import Modal from "components/Modal";

import { setGAInLocalstorage } from "methods/ga";
import * as Client from "api/client";
import * as ga from "methods/ga";

import {
  customerStatus,
  GA_trackId,
  stage,
  baseRoute,
  lineOAUrl,
} from "config/const";
import "./App.css";

ReactGA4.initialize(GA_trackId, {
  debug: stage === "development",
  titleCase: false,
});

function App() {
  const [openActivityEndModal, setOpenActivityEndModal] = useState(false);
  const {
    auth: { accessToken, userId },
    isActivityEnd,
    userVerify,
  } = useAuth();

  useEffect(() => {
    setOpenActivityEndModal(isActivityEnd);
    console.log(openActivityEndModal);
  }, [isActivityEnd]);

  useEffect(() => {
    const qs = window.location.search;
    const location = window.location.pathname;

    if (!userVerify) return;
    if (
      [customerStatus.UNAUTHORIZED, customerStatus.REDEEMED].includes(
        userVerify
      )
    ) {
      if (location !== "/home")
        window.location.replace(`${baseRoute}/home${qs}`);
    } else {
      if (["/home", "/"].includes(location))
        window.location.replace(`${baseRoute}/exchange${qs}`);
    }
  }, [userVerify]);

  useEffect(() => {
    async function addTag() {
      const qs = new URLSearchParams(window.location.search);
      const ga_utm_source = qs.get("utm_source");
      const ga_utm_medium = qs.get("utm_medium");
      const ga_utm_campaign = qs.get("utm_campaign");
      const ga_utm_term = qs.get("utm_term");
      const ga_utm_id = qs.get("utm_id");
      setGAInLocalstorage({
        ga_utm_source,
        ga_utm_medium,
        ga_utm_campaign,
        ga_utm_term,
        ga_utm_id,
      });

      if (ga_utm_term) {
        const res = await Client.addTag(userId, {
          tagName: ga_utm_term,
          accessToken,
        });
        if (!res.err && !res.error) {
          ga.sendGATagEvent(userId, "addTag");
        }
      }
    }
    if (userId && accessToken) addTag();
  }, [accessToken, userId]);

  const directToOfficialWeb = () => {
    window.location.replace("https://lihi1.com/ufCc9");
  };

  const goLineOa = () => {
    window.location.replace(lineOAUrl);
  };

  return (
    <div className="App">
      {!userVerify && <Loading />}
      {userId && (
        <div className="App-content">
          <BrowserRouter>
            <Routes>
              {routes.map((routeItem) => {
                return (
                  <Route
                    key={routeItem.key}
                    path={routeItem.path}
                    exact={routeItem.exact}
                    element={routeItem.element}
                  />
                );
              })}
            </Routes>
          </BrowserRouter>
        </div>
      )}
      <Modal open={openActivityEndModal} setOpen={() => {}}>
        <Box sx={ModalStyle}>
          <Typography variant="body1" color="white">
            謝謝您的參與，活動已結束，點擊探索更多新品「魚子美顏緊緻塑顏精萃」。
          </Typography>
          <WhiteButton sx={{ border: 0 }} block onClick={directToOfficialWeb}>
            探索更多
          </WhiteButton>
          <WhiteButton sx={{ border: 0 }} block onClick={goLineOa}>
            回到La Prairie官方帳號
          </WhiteButton>
        </Box>
      </Modal>
    </div>
  );
}

export default App;
